export interface IAircraftModel {
	aircraftModelId?: number;
	aircraftModelRecordId?: number;
	name?: string;
	effectiveStart?: string;
	effectiveEnd?: string;
}

export class AircraftModel {
	name?: string;
	effectiveStart?: string;
}
